import { getBackendUrl } from "../config";

function stripTrailingSlash(url) {
	return typeof url === "string" ? url.replace(/\/+$/, "") : url;
}

function isLocalhost(hostname) {
	return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "0.0.0.0";
}

export function getFrontendBackendBaseUrl() {
	const base = getBackendUrl() || process.env.REACT_APP_BACKEND_URL || "";
	return stripTrailingSlash(base);
}

export function normalizeUrlToBackend(value, baseUrl = getFrontendBackendBaseUrl()) {
	if (!value || typeof value !== "string" || !baseUrl) return value;

	// Absolute URL
	try {
		const parsed = new URL(value);
		if (isLocalhost(parsed.hostname)) {
			return `${baseUrl}${parsed.pathname}${parsed.search}${parsed.hash}`;
		}
		return value;
	} catch (err) {
		// Not an absolute URL
	}

	// Relative URL/path
	if (value.startsWith("/")) {
		return `${baseUrl}${value}`;
	}

	if (value.startsWith("public/")) {
		return `${baseUrl}/${value}`;
	}

	return value;
}

const URL_KEYS = new Set([
	"mediaUrl",
	"urlPicture",
	"profilePicUrl",
	"profileImage",
	"avatar",
	"mediaPath"
]);

export function normalizeUrlsDeep(data, baseUrl = getFrontendBackendBaseUrl()) {
	if (!data || !baseUrl) return data;

	if (Array.isArray(data)) {
		for (let i = 0; i < data.length; i++) {
			data[i] = normalizeUrlsDeep(data[i], baseUrl);
		}
		return data;
	}

	if (typeof data === "object") {
		for (const key of Object.keys(data)) {
			const value = data[key];

			if (URL_KEYS.has(key)) {
				data[key] = normalizeUrlToBackend(value, baseUrl);
				continue;
			}

			if (value && (typeof value === "object" || Array.isArray(value))) {
				data[key] = normalizeUrlsDeep(value, baseUrl);
			}
		}
		return data;
	}

	return data;
}
